import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AppStatusSlice = {
  isMainAppLoading: boolean;
  displayMainAppError: boolean;
  displayMainAppErrorMessage: string;
  executingBaseRequests: boolean;
  baseRequestsFailed: boolean;
  baseRequestsFailedMessage: string;
};

const initialState: AppStatusSlice = {
  isMainAppLoading: false,
  displayMainAppError: false,
  displayMainAppErrorMessage: "",
  executingBaseRequests: false,
  baseRequestsFailed: false,
  baseRequestsFailedMessage: ""
};

const appStatusSlice = createSlice({
  name: "appStatus",
  initialState,
  reducers: {
    startExecuteBaseRequests(state) {
      state.isMainAppLoading = true;
      state.executingBaseRequests = true;
      state.baseRequestsFailed = false;
      state.baseRequestsFailedMessage = "";
    },
    executeBaseRequestsSuccess(state) {
      state.isMainAppLoading = false;
      state.executingBaseRequests = false;
      state.baseRequestsFailed = false;
      state.baseRequestsFailedMessage = "";
    },
    executeBaseRequestsFail(state, action: PayloadAction<string>) {
      state.isMainAppLoading = false;
      state.executingBaseRequests = false;
      state.baseRequestsFailed = true;
      state.baseRequestsFailedMessage = action.payload;
    },
    setDisplayMainAppError(
      state,
      action: PayloadAction<{ displayMainAppError: boolean; message: string }>
    ) {
      state.isMainAppLoading = false;
      state.displayMainAppError = true;
      state.displayMainAppErrorMessage = action.payload.message;
    },
    resetApp() {
      /**/
    }
  }
});
export const {
  startExecuteBaseRequests,
  executeBaseRequestsSuccess,
  executeBaseRequestsFail,
  setDisplayMainAppError,
  resetApp
} = appStatusSlice.actions;

export default appStatusSlice.reducer;
